import { useTranslation } from "react-i18next";
import { NumberFormatText } from "../../../components/NumberFormatText";
import KiloNewton from "../../../components/Math/Units/Metric/KiloNewton";
import { RowBody } from "../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../components/ToolTip";

function DesignLoadCarryingCapacity({ Rcd }) {
  const { t } = useTranslation("translation");
  const RcdFormula = `\\displaystyle R_{d} = \\frac{R_{k}}{\\gamma_{ _{ _{\\tiny M}}}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.verificationCapacity.designLoadCarryingCapacity")}</p>}
      formulaValue={<ToolTip id={"RcdFormula"} type={IconType.FORMULA} formula={RcdFormula} />}
      indicesValue={
        <span>
          R<sub>d</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={Number(Rcd)} decimalScale={0} />
        </span>
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default DesignLoadCarryingCapacity;
